// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"24":"1b4d727d","83":"a1d468de","901":"a23e23b7"}[chunkId] + ".css";
};